/*
  DCI TECH Guatemala - complements by PRODUCT TYPE (2026-10-03). Shared by the cart ("Combina con tu compra")
  and the product page ("Lo que suele acompañarlo") so both always recommend the same way.

  DCIRecs.complements({ type, price, exclude: [productIds] }) -> Promise<[{id,t,u,ven,type,i,p,vid}]>
  - type: the product's Shopify type (Router, NVR, Laptop...). Unknown types get general accessories.
  - Candidates come from templates/search.dci-recs.liquid (product_type search as JSON; unavailable and
    quote-only business products already left out). Only items with a photo, cheaper than `price`.
  Replaces the old collection map, which offered Starlink routers (substitutes, no photos) for a router.
*/
(function () {
  if (window.DCIRecs) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var G = {
    net: ['Router', 'Punto de Acceso', 'Expansión de Red', 'Switch / Hub', 'Satellite Internet Router', 'Router Satelital', 'Adaptador de Red', 'Accesorio de Red'],
    lap: ['Laptop', 'Notebook', 'Notebook 2-en-1'],
    desk: ['Desktop', 'Desktop Computer', 'Computadora de Mesa', 'All-in-One PC', 'Todo-en-Uno'],
    mon: ['Monitor', 'Monitor / Pantalla', 'Televisor'],
    rec: ['NVR', 'DVR', 'Network Recorder & Storage'],
    cam: ['Cámara IP', 'Cámara de Seguridad', 'Security Camera', 'Cámara Análoga'],
    prn: ['Impresora Inkjet', 'Impresora Láser', 'Impresora Multifuncional', 'Impresora Matricial'],
    pos: ['Impresora de Recibos', 'Handheld POS', 'Lector', 'Lector / Teclado POS', 'Caja de Dinero', 'Computadora Handheld'],
    phone: ['Smartphone', 'Tablet', 'Smartwatch'],
    dish: ['Satellite Dish', 'Antena Satelital'],
    ups: ['UPS', 'Regulador de Voltaje'],
    voip: ['Teléfono IP', 'VoIP & Connect'],
    proj: ['Proyector']
  };
  var COMP = {
    net: ['Cable de Red', 'Accesorio de Red', 'Protector de Voltaje', 'UPS', 'Switch / Hub'],
    lap: ['Mochila', 'Maletín para Notebook', 'Ratón', 'Docking Station', 'Hub USB', 'SSD Externo'],
    desk: ['Combo Teclado / Ratón', 'Monitor', 'Regulador de Voltaje', 'Cámara Web', 'Bocina'],
    mon: ['Soporte y Montaje', 'Cable A/V', 'Accesorio de Monitor', 'Regulador de Voltaje'],
    rec: ['Disco Duro Interno', 'Cámara IP', 'Fuente de Poder', 'Cable de Red', 'UPS'],
    cam: ['NVR', 'Disco Duro Interno', 'Tarjeta de Memoria', 'Accesorio de Cámara', 'Fuente de Poder'],
    prn: ['Cartucho / Tóner', 'Papel', 'Papel e Insumos', 'Regulador de Voltaje'],
    pos: ['Papel', 'Consumible POS', 'Caja de Dinero', 'Lector'],
    phone: ['Estuche para Celular', 'Cargador', 'Power Bank', 'Auriculares', 'Tarjeta de Memoria'],
    dish: ['UPS', 'Cable de Red', 'Router', 'Protector de Voltaje'],
    ups: ['Protector de Voltaje', 'Regulador de Voltaje', 'Cable'],
    voip: ['Switch / Hub', 'Cable de Red', 'Auriculares'],
    proj: ['Pantalla de Proyección', 'Cable A/V', 'Soporte y Montaje'],
    _: ['Ratón', 'Protector de Voltaje', 'Memoria USB', 'Cable']
  };
  function typesFor(type) {
    for (var g in G) if (G[g].indexOf(type) > -1) return COMP[g].filter(function (t) { return t !== type; });
    return COMP._;
  }
  var cache = {};
  function byType(t) {
    if (!cache[t]) cache[t] = fetch(root + 'search?type=product&options[prefix]=none&q=' + encodeURIComponent('product_type:"' + t + '"') + '&view=dci-recs')
      .then(function (r) { return r.json(); })
      .then(function (j) { return j.filter(function (x) { return x.type === t; }); })
      .catch(function () { return []; });
    return cache[t];
  }
  function complements(o) {
    var cap = Number(o.price) || 0, ex = {}, max = o.max || 4;
    (o.exclude || []).forEach(function (id) { ex[String(id)] = 1; });
    var types = typesFor(o.type);
    return Promise.all(types.map(byType)).then(function (lists) {
      var pick = [], seen = {};
      function ok(x) { return x.i && !seen[x.id] && !ex[String(x.id)] && (!cap || x.p <= cap); }
      // round 1: one per complement type (variety), round 2: fill up to max from the same types
      lists.forEach(function (l) { var x = l.filter(ok)[0]; if (x && pick.length < max) { pick.push(x); seen[x.id] = 1; } });
      lists.forEach(function (l) { l.forEach(function (y) { if (pick.length < max && ok(y)) { pick.push(y); seen[y.id] = 1; } }); });
      return pick;
    });
  }
  window.DCIRecs = { complements: complements, typesFor: typesFor };
})();
